// Dream 100 — portal entry (owned by the dream100 feature).
import { Crown } from "lucide-react";
import { RequireIgAccount } from "../../lib/igAccount";
import type { FeatureModule } from "../registry";

const dream100: FeatureModule = {
  id: "dream100",
  // First in Growth: the list every other growth automation works from.
  nav: [{ to: "/dream100", label: "Dream 100", icon: Crown, group: "growth", order: 1, end: true }],
  routes: [
    {
      path: "/dream100",
      lazy: async () => {
        const { Dream100Page } = await import("./Dream100Page");
        return {
          Component: () => (
            <RequireIgAccount>
              <Dream100Page />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/dream100/plan",
      lazy: async () => {
        const { PlanPage } = await import("./Dream100Page");
        return {
          Component: () => (
            <RequireIgAccount>
              <PlanPage />
            </RequireIgAccount>
          ),
        };
      },
    },
  ],
};

export default dream100;
